// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 501 ? "bc98253f" : chunkId) + "." + {"501":"d13bf505216111a2","6457":"bf17968eb01e51e6","9839":"c4b12f3390b067b2"}[chunkId] + ".js";
};